<template>
  <div class="mx-auto w-full max-w-7xl px-4 pb-16 pt-10 md:px-8 md:pt-16">
    <header class="mb-8">
      <p class="text-xs uppercase tracking-[0.3em] text-[var(--accent)]">{{ $t('fullStackPage.kicker') }}</p>
      <h1 class="mt-3 text-3xl font-bold text-[var(--text-primary)] md:text-5xl">{{ $t('fullStackPage.title') }}</h1>
      <p class="mt-4 max-w-3xl text-[var(--text-muted)]">
        {{ $t('fullStackPage.subtitle') }}
      </p>
    </header>

    <section class="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
      <article
        v-for="pillar in content.pillars"
        :key="pillar.titleKey"
        class="panel p-5 transition duration-300 hover:-translate-y-1"
      >
        <h2 class="text-base font-semibold text-[var(--text-primary)]">{{ $t(pillar.titleKey) }}</h2>
        <p class="mt-2 text-sm text-[var(--text-muted)]">{{ $t(pillar.detailsKey) }}</p>
      </article>
    </section>

    <section class="mt-8 panel p-6">
      <h2 class="text-xl font-bold text-[var(--text-primary)]">{{ $t('fullStackPage.productionTitle') }}</h2>
      <div class="mt-4 grid gap-4 md:grid-cols-2">
        <article
          v-for="example in content.productionExamples"
          :key="example.titleKey"
          class="rounded-xl border border-[var(--border)] bg-[var(--chip-bg)] p-5"
        >
          <h3 class="text-base font-semibold text-[var(--text-primary)]">{{ $t(example.titleKey) }}</h3>
          <p class="mt-2 text-sm text-[var(--text-muted)]"><strong class="text-[var(--text-secondary)]">{{ $t('fullStackPage.labels.decision') }}:</strong> {{ $t(example.decisionKey) }}</p>
          <p class="mt-2 text-sm text-[var(--accent)]"><strong>{{ $t('fullStackPage.labels.impact') }}:</strong> {{ $t(example.impactKey) }}</p>
        </article>
      </div>
    </section>
  </div>
</template>

<script>
import { FULLSTACK_ENGINEERING_SECTIONS } from '@/constants/domainContent';

export default {
  name: 'FullStackPage',
  data() {
    return {
      content: FULLSTACK_ENGINEERING_SECTIONS,
    };
  },
};
</script>
